module.exports = __webpack_public_path__ + "static/img/Alec_Tuitavake.e07b2fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alec_Tuitavake.jpg
// module id = wQ21
// module chunks = 0